<template>
	<div class="admin">
		<sidebar :class="sidebarClasses" @navigate="closeSidebar" />
		<container class="admin__content" @click.native="closeSidebar" />
	</div>
</template>

<script>
import Sidebar from '@/components/admin/Sidebar'
import Container from '@/components/admin/Container'

export default {
	name: 'admin',
	computed: {
		sidebarClasses() {
			const open = this.$store.state.sidebar.open
			return ['admin__sidebar', { 'admin__sidebar--open': open }]
		}
	},
	methods: {
		closeSidebar() {
			if (this.$store.state.sidebar.open) {
				this.$store.commit('sidebar/close')
			}
		}
	},
	components: {
		Sidebar,
		Container
	}
}
</script>

<style lang="scss">
@import '~scss/vars';
@import '~scss/mq';

.admin {
	display: flex;
	height: 100vh;

	&__sidebar {
		flex-shrink: 0;

		@include mq-max(lg) {
			position: fixed;
			height: 100%;
			transform: translateX(-100%);
			box-shadow: none;
			transition: transform 0.25s $ease-out-sine,
				box-shadow 0.25s $ease-out-sine;

			&--open {
				box-shadow: 0.1875rem 0 1.5rem 0 rgba($black, 0.5);
				transform: none;
			}
		}
	}
	&__content {
		flex-grow: 1;
	}
}
</style>
